<section>
  <div class="form-register">
    <form [formGroup]="formOrderDetail">
      <div class="row mb-1">
        <div class="col-lg-3 col-md-6 col-sm-6 col-12">
          <app-custom-input-text [value]="codeNameArticle" [disabled]="true" [labelText]="'Artículo'">
          </app-custom-input-text>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="workshopStock" [labelText]="'Taller'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="shopStock" [labelText]="'Almacén'"></app-custom-input-decimal>
        </div>
        <div class="col-lg-1 col-md-2 col-sm-3 col-6">
          <app-custom-input-decimal formControlName="quantityFinal" [labelText]="'Cant.Fin.'"
            (onChangeNumber)="changeQuantityFinal()"></app-custom-input-decimal>
        </div>
        <div class="col-lg-3 col-md-4 col-sm-12 col-12 d-flex mt-2">
          <div class="d-flex align-items-end gap-1">
            <app-custom-button [label]="'Guardar'" [severity]="'primary'" [disabled]="disableButtonSave"
              (onClick)="send()"></app-custom-button>
            <app-custom-button [label]="'Cancelar'" [severity]="'danger'" (onClick)="clearForm()"></app-custom-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</section>